import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
import { LoggerService } from './logger.service';
import { ToastService } from './toast.service';

const SEARCH_PATH = '/task';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
    private configService: ConfigurationService,
    private toastService: ToastService) {}

    searchData(params: any): Observable<HttpResponse<any>>{
      return this.configService.getHostApi().pipe(
        switchMap((hostApi: string) =>
          this.http
            .get(`${hostApi}${SEARCH_PATH}`, {
              params,
              observe: "response"
            })
            .pipe(
              catchError((error: HttpErrorResponse) => this.handleError(error, 'Search data failed'))
            )
        )
      );
    }

    private handleError(error: HttpErrorResponse, message: string) {
      this.toastService.show('HTTP Error Occurred!', { classname: 'bg-danger text-light', delay: 8000 });
      if (error.status === 0) {
        this.logger.error(`${message}:`, error.error);
      } else {
        this.logger.error(`${message}: ${error.status}, body was: ${error.error}`);
      }
      return throwError(error);
    }
}
